import { render } from "./LibraryBooks.vue?vue&type=template&id=8a1d001a&scoped=true"
import script from "./LibraryBooks.vue?vue&type=script&lang=js"
export * from "./LibraryBooks.vue?vue&type=script&lang=js"

import "./LibraryBooks.vue?vue&type=style&index=0&id=8a1d001a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a1d001a"]])

export default __exports__